import React from "react";
import { Box, Heading } from "@chakra-ui/react";
import TrendIndicator from "./TrendIndicator";
import CompareButton from "./CompareButton";
import StatValue from "./StatValue";

interface MetricCardProps {
  title: string;
  value: any;
  trendValue: any;
  format?: "percent" | "score" | "number";
  maxValue?: number;
  isPoints?: boolean;
  onCompare?: () => void;
}

const MetricCard: React.FC<MetricCardProps> = ({
  title,
  value,
  trendValue,
  format = "percent",
  maxValue,
  isPoints = false,
  onCompare
}) => {
  const handleCompare = () => {
    if (onCompare) {
      onCompare();
    }
  };

  return (
    <Box
      as="section"
      position="relative"
      bg="white"
      borderRadius="md"
      boxShadow="sm"
      p={4}
      h="109px"
      flex="1"
      minW="250px"
      maxW="376px"
      overflow="visible"
    >
      <TrendIndicator value={trendValue} isPoints={isPoints} />
      <CompareButton onClick={handleCompare} />
      
      <Box position="relative">
        <Heading as="h2" size="md" mb={2} fontWeight="medium">
          {title}
        </Heading>
        <StatValue value={value} format={format} maxValue={maxValue} />
      </Box>
    </Box>
  );
};

export default MetricCard; 